//  show modal action
import { SET_REDUX_CONFIRM_MODAL_DATA, SET_REDUX_CONFIRM_MODAL_SHOW } from "../types";

export const showModal = (show = true) => {
    return {
        type: SET_REDUX_CONFIRM_MODAL_SHOW,
        payload: { show }
    };
};

//  set modal data action
export const setModalData = (data = {}) => {
    return {
        type: SET_REDUX_CONFIRM_MODAL_DATA,
        payload: { ...data }
    };
};
